import { useEffect, useState } from "react";
import api from "../../../../../services/Api";
import { toast } from "react-toastify";
import styles from "./ImagensColeta.module.css";
import { useParams } from "react-router-dom";
import { Modal } from "@mui/material";

export default function ImagensColeta() {
  const { id } = useParams();
  const [imagens, setImagens] = useState([]);
  const [openModalImage, setOpenModalImage] = useState(false);
  const [image, setImage] = useState(null);

  const [zoom, setZoom] = useState(1);
  const [origin, setOrigin] = useState("center center");

  const handleMouseMove = (e) => {
    const { left, top, width, height } = e.target.getBoundingClientRect();

    const x = ((e.clientX - left) / width) * 100;
    const y = ((e.clientY - top) / height) * 100;

    setOrigin(`${x}% ${y}%`);
  };

  const handleMouseEnter = () => {
    setZoom(2); // nível do zoom
  };

  const handleMouseLeave = () => {
    setZoom(1);
    setOrigin("center center");
  };

  const getImagensColeta = async (idColeta) => {
    if (idColeta) {
      await api
        .post(`motorista/roteirodetalhecoletaimg/${idColeta}`)
        .then((res) => {
          if (res.data.error === 0) {
            setImagens(res?.data?.serializedImg);
          }
          if (res.data.error === 1) {
            console.log(res.data.msg);
          }
        })
        .catch((error) => {
          toast.error("Erro ao buscar imagens");
        });
    }
  };

  const viewImage = (image) => {
    console.log(image);
    setOpenModalImage(true);
    setImage(image);
  };

  const closeModal = () => {
    setOpenModalImage(false);
    setImage(null);
  };

  useEffect(() => {
    getImagensColeta(id);
  }, []);

  return (
    <section className={styles.images_section}>
      {imagens.length !== 0 ? (
        <div className={styles.container}>
          {imagens.map((values) => (
            <div
              className={styles.image_container}
              onClick={() => viewImage(values)}
            >
              <img
                src={values?.image_url}
                key={values?.id}
                alt="Imagem da Coleta"
              />
              <span>
                Visualizar <i className="fas fa-search"></i>
              </span>
            </div>
          ))}
        </div>
      ) : (
        <h2>Nenhuma imagem cadastrada</h2>
      )}
      <Modal
        open={openModalImage}
        onClose={(event, reason) => {
          closeModal();
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div className={styles.container_modal_image}>
          <span className={styles.close_button} onClick={() => closeModal()}>
            <i className="fas fa-times fa-lg"></i>
          </span>
          {image && (
            <img
              src={image.image_url}
              key={image.id}
              alt="Imagem da Coleta"
              onMouseMove={handleMouseMove}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
              style={{
                transform: `scale(${zoom})`,
                transformOrigin: origin,
              }}
            />
          )}
        </div>
      </Modal>
    </section>
  );
}
